// Korean phone number normalization & display formatting helpers.
// Treats hyphens, spaces, and country prefix (+82) as cosmetic — same person
// regardless of input form. Backend stores E.164 ('+821012345678'); UI shows
// '010-XXXX-XXXX' for readability.

const NON_DIGITS = /[^0-9]/g;

// Strip all non-digits, then return mobile-only canonical form '01XXXXXXXXX'.
// '010-1234-5678'   → '01012345678'
// '01012345678'     → '01012345678'
// '+821012345678'   → '01012345678'
// '+82 10 1234 5678'→ '01012345678'
export function digitsOnly(input) {
  if (!input) return '';
  let d = String(input).replace(NON_DIGITS, '');
  if (d.startsWith('82') && d.length >= 10) d = '0' + d.slice(2);
  return d;
}

// Format for display while user is typing. Adds hyphens at 010-XXX-XXXX or 010-XXXX-XXXX.
// 010      → 010
// 0101234  → 010-1234
// 01012345678 → 010-1234-5678
// 0101234567  → 010-123-4567 (10-digit edge case)
export function formatKoreanPhone(input) {
  const d = digitsOnly(input);
  if (!d) return '';
  if (d.length <= 3) return d;
  if (d.length <= 7) return `${d.slice(0, 3)}-${d.slice(3)}`;
  if (d.length === 10) return `${d.slice(0, 3)}-${d.slice(3, 6)}-${d.slice(6)}`;
  return `${d.slice(0, 3)}-${d.slice(3, 7)}-${d.slice(7, 11)}`;
}

// Same person? Compare digit-only forms.
export function samePhone(a, b) {
  return !!a && !!b && digitsOnly(a) === digitsOnly(b);
}

// E.164 form for backend compatibility (matches lambda/otp normalizePhone output).
export function toE164(input) {
  const d = digitsOnly(input);
  if (!d.startsWith('01') || d.length < 10 || d.length > 11) return null;
  return '+82' + d.slice(1);
}

// Detect whether a free-text login input looks like a phone number (vs an email).
// Used by handleSignIn to auto-convert phone input into the fake-email username
// (phone_{e164digits}@koa-asia.com) so the same pool accepts both forms.
// Rules: no '@' AND 9-11 digit count once non-digits are stripped AND starts with '01'.
export function isPhoneInput(value) {
  const trimmed = String(value || '').trim();
  if (!trimmed || trimmed.includes('@')) return false;
  const d = digitsOnly(trimmed);
  return d.length >= 9 && d.length <= 11 && d.startsWith('01');
}

// Build the fake-email username Cognito requires when the user signed up with
// phone+name only. Keep this aligned with lambda/presignup FAKE_EMAIL_PATTERN
// (/^phone_\d{9,11}@koa-asia\.com$/i). Changing the domain breaks all existing
// fake-email users.
export function buildFakeEmail(phone) {
  const d = digitsOnly(phone);
  return `phone_${d}@koa-asia.com`;
}
